import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events'
class ScallopStacking {
	constructor() {
		this.layers = []

		this.prepareLayers()
		console.log('ScallopStacking layers', this.layers)
		this.orderLayers()
	}
	prepareLayers() {
		this.layers = Array.from(document.querySelectorAll('[data-scallop-layer]'))
	}
	orderLayers() {
		this.layers.forEach((layer, index) => {
			layer.style.zIndex = this.layers.length - index
		})
	}
	reset() {
		this.layers.forEach((layer) => {
			layer.style.zIndex = ''
		})
		this.layers = []
	}
	refresh() {
		this.layers = Array.from(document.querySelectorAll('[data-scallop-layer]'))
		this.orderLayers()
	}
	destroy() {
		this.layers.forEach((layer) => {
			layer.style.zIndex = ''
		})
		this.layers = []
	}
}

//
export default class extends Component {
	prepare() {
		console.log('aaaa')
		this.scallopStacking = new ScallopStacking()

		this.bndOnSwupPageView = this.onSwupPageView.bind(this)
		EventBus.on(Events.SWUP_PAGE_VIEW, this.bndOnSwupPageView)
		// A layer can rewrite its own DOM after mount (e.g. the home intro wraps
		// itself for its pin), which moves where the z-index has to land. Let it
		// ask for a restack instead of racing the page:view one.
		EventBus.on(Events.SCALLOP_RESTACK, this.bndOnSwupPageView)
	}

	mount() {}

	unmount() {
		EventBus.off(Events.SWUP_PAGE_VIEW, this.bndOnSwupPageView)
		EventBus.off(Events.SCALLOP_RESTACK, this.bndOnSwupPageView)

		if (this.scallopStacking) {
			this.scallopStacking.destroy()
			this.scallopStacking = null
		}
	}
	//
	onSwupPageView() {
		if (this.scallopStacking) {
			this.scallopStacking.refresh()
		}
	}
}
